import { getClient } from '@/lib/api/client'
import type { AiUserFollowUpKind } from '@/lib/api/ai-user/ai-user-api'

/**
 * Guias da venda paga, como arquivos para anexar na conversa (docs/ai-user.md, "Fase 2,
 * etapa 3"). As mesmas rotas do botão de PDF de cada atendimento; para o usuário de IA o
 * backend só as libera com a cobrança paga.
 */
const GUIDE_PATH: Record<AiUserFollowUpKind, (id: number) => string> = {
    EXAM: id => `exams/${id}/order/pdf`,
    CONSULTATION: id => `consultations/${id}/pdf`,
    PROCEDURE: id => `orders/${id}/pdf`,
}

const GUIDE_FILE: Record<AiUserFollowUpKind, string> = {
    EXAM: 'guia-exame',
    CONSULTATION: 'guia-consulta',
    PROCEDURE: 'guia-procedimento',
}

export async function fetchGuideFiles(appointments: Array<{ kind: AiUserFollowUpKind; id: number }>): Promise<File[]> {
    const client = getClient()
    return Promise.all(
        appointments.map(async ({ kind, id }) => {
            const response = await client.get(GUIDE_PATH[kind](id), { responseType: 'blob' })
            return new File([response.data], `${GUIDE_FILE[kind]}-${id}.pdf`, { type: 'application/pdf' })
        }),
    )
}
